global.jQuery = require('jquery');
global.$ = global.jQuery;

import * as core from '../libs/tech.core'
import * as lazyLoad from '../libs/tech.lazy-load'
import * as scrollup from '../libs/tech.scrollup'
import * as blogLikes from '../libs/tech.blogLikes'
import * as shared from '../libs/tech.shared'
import * as phone from '../libs/tech.phone'
import * as captchaV3 from '../libs/tech.captchaV3'

$(function () {
    lazyLoad.initLazyLoad('.lazyBackground');
    lazyLoad.initLazyLoad('.anim-trigger');
})

//more imports here

export { core, lazyLoad, scrollup, blogLikes, shared, phone, captchaV3 }